import { useState } from "react";
import Table from "../../components/Table/index.jsx";
import { FaDownload, FaEye } from "react-icons/fa";
import { useQuery } from "@apollo/client";
import { GET_FRANCHISE_DEPOSITE } from "../../graphql/Query/Deposite.js";
import { useLocation } from "react-router-dom";
import { IMAGE_URL } from "../../config.js";
const FranchiseProfileDetails = () => {
    const location = useLocation()
    const [showModal, setShowModal] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const handleOpenImage = (imageUrl) => {
        setModalImage(imageUrl);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalImage("");
    };

    const [formData, setFormData] = useState({
        fromDate: "",
        toDate: "",
        transactionId: "",
    });

    const { data, loading } = useQuery(GET_FRANCHISE_DEPOSITE, {
        variables: {
            franchiseId: location?.state?.id,
            page,
            limit,
            from: formData.fromDate || null,
            to: formData.toDate || null,
            search: formData.transactionId || null,
            sort: { key: 'createdAt', type: -1 },
        },
        fetchPolicy: "cache-and-network"
    });

    const handleReset = () => {
        setFormData({
            fromDate: "",
            toDate: "",
            transactionId: "",
            SenderName: "",
            type: "all",
        });
    };

    const orderTableColumns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            width: "60px",
        },
        {
            name: "Received Date",
            selector: (row) => {
                const timestamp = Number(row?.createdAt);   // convert string → number
                return new Date(timestamp).toLocaleDateString();
            },
        },
        {
            name: "Amount",
            selector: (row) => row.amount,
            cell: (row) => <span>₹ {row.amount}</span>,
        },
        {
            name: "Transaction ID",
            selector: (row) => row.transactionId,
            cell: (row) => <span className="text-xs text-blue-600">{row.transactionId}</span>,
        },
        {
            name: "Photo",
            cell: (row) => (
                <button onClick={() => handleOpenImage(row?.photo)}>
                    <FaEye size={18} />
                </button>
            ),
        },
        {
            name: "Download",
            cell: (row) => (
                <a href={row?.pdfUrl} download target="_blank">
                    <FaDownload size={18} />
                </a>
            ),
        },
    ];

    const handlePagination = (page) => {
        setPage(page?.selected);
    };
    return (
        <>
            <div className="w-full px-4 pt-6 pb-10 border border-gray-200 md:rounded-md bg-white">
                {/* Heading */}
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                    <p className="text-lg font-bold text-slate-800">Franchise Deposite Details</p>

                </div>

                <div className="text-gray-600 grid grid-cols-1">
                    <Table
                        columns={orderTableColumns}
                        data={data?.getFranchiseDepositeForAdmin?.data || []}
                        currentPage={page}
                        totalRecords={data?.getFranchiseDepositeForAdmin?.count || 0}
                        limit={limit}
                        setLimit={setLimit}
                        setPage={setPage}
                        loading={loading}
                        // deleteData={DeleteProduct}
                        handlePagination={handlePagination}
                    // multiSelectRow={onSelectedRowsChange}
                    // clearSelectedRows={toggleCleared}
                    />
                </div>
                {/* Modal */}
                {showModal && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                        <div className="bg-white rounded-lg shadow-lg p-4 w-96 relative">
                            <button
                                onClick={handleCloseModal}
                                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 font-bold"
                            >
                                ✕
                            </button>
                            <img src={`${IMAGE_URL}/${modalImage}`} alt="hh" className="w-full h-auto rounded" />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default FranchiseProfileDetails;
